import { useEffect, useState } from 'react';
import api from '../utils/functions/api';

// รหัสนำหน้าเลขโครงการที่ถือว่า "ได้ค่าออกสนาม" เป็นค่าเริ่มต้น (Information.field_allowance_default_prefixes,
// ตั้งที่ /management/project-prefixes) — ไม่ได้ตั้ง/โหลดไม่ได้ = JS ตามกติกาเดิม
export const DEFAULT_FIELD_ALLOWANCE_PREFIXES = ['JS'];

let cached = null;
let inflight = null;

export const setFieldAllowancePrefixesCache = (list) => {
  cached = list;
};

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api
      .get(`${process.env.REACT_APP_API_URL}/information/`)
      .then((res) => {
        const list = res.data?.field_allowance_default_prefixes;
        cached = Array.isArray(list) && list.length ? list : DEFAULT_FIELD_ALLOWANCE_PREFIXES;
        return cached;
      })
      .catch(() => DEFAULT_FIELD_ALLOWANCE_PREFIXES)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export default function useFieldAllowanceDefaultPrefixes() {
  const [prefixes, setPrefixes] = useState(cached || DEFAULT_FIELD_ALLOWANCE_PREFIXES);
  useEffect(() => {
    let alive = true;
    load().then((list) => alive && setPrefixes(list));
    return () => {
      alive = false;
    };
  }, []);
  return prefixes;
}
